export default {
  silly: () => {},
  info: () => {},
  error: err => {
    console.error(err);
  },
  verbose: () => {}
};
